export default "https://cdn-shared.mathletics.com/teacher-modules/mathletics-library/38/assets/images/icon_empty.fc70c2b71fddace56dc203584e6d4583.svg";